export default __webpack_public_path__ + "static/media/50n.89cbcff3.jpg";